import { render, staticRenderFns } from "./footBtns.vue?vue&type=template&id=167279d2&scoped=true&"
import script from "./footBtns.vue?vue&type=script&lang=js&"
export * from "./footBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167279d2",
  null
  
)

export default component.exports